import axios from "lib/axios";
import {
  handleget_headers_params,
  initFilterUrlLikelihood,
  initFilterUrl,
  showToastr,
  redirect,
  clearStorage,
} from "pages/Utils";

const api_axios = "/api";
export const redirect403 = () => {
  clearStorage();
  showToastr("warning", "Anda harus login terlebih dahulu");
  return redirect("/login");
};

export const api_services = ({ api_path } = {}) => {
  // const [cancel, setcancel] = useState(null)

  const csrf = () => axios.get("/sanctum/csrf-cookie");
  var controller = {};

  const getapi_services = async ({ setErrors, ...props }) => {
    // await csrf()

    // if(cancel !== null) {

    // }
    if (setErrors) {
      setErrors([]);
    }

    var urllocal = api_path;
    if (props.api_path) {
      urllocal = props.api_path;
    }

    const filter_url = initFilterUrl({
      url: `${api_axios}${urllocal}`,
      filter: props.filter,
    });

    if (controller[urllocal]) controller[urllocal].abort();

    // console.log("urllocal")
    // console.log(urllocal)
    controller[urllocal] = new AbortController();

    return await axios(handleget_headers_params())
      // .get(filter_url, props)
      .get(filter_url, {
        ...props,
        signal: controller[urllocal].signal,
        // cancelToken: new CancelToken(function executor(c) {
        //     setcancel(c);
        // })
      })
      .then((res) => res.data)
      .catch((error) => {
        // console.log("error123", error);
        // console.log("error.AxiosError", error.AxiosError);
        // console.log("error.message", error.message);
        // console.log("error.response.status", error.response.status);
        if (error && error.response && error.response.status == 403) {
          clearStorage();
          // router.push("/login");
          redirect("/login");
          return;
        }

        if (error.response == undefined) return { error };
        else return error.response.data;

        if (error.response.status !== 422) throw error;
        setErrors(error.response.data.errors);

        c;
      });
  };

  const getapi_servicesid = async ({ setErrors, ...props }) => {
    // await csrf()

    var urllocal = api_path;
    if (props.api_path) {
      urllocal = props.api_path;
    }

    if (props.id) urllocal = urllocal + "/" + props.id;

    if (setErrors) {
      setErrors([]);
    }

    return await axios(handleget_headers_params())
      .get(`${api_axios}${urllocal}`, props)
      .then((res) => {
        // console.log('then')
        return res.data;
      })
      .catch((error) => {
        // console.log('err')
        // console.log(error)
        if (
          error.response.data.messages &&
          error.response.data.messages.error
        ) {
          if (!props.disabledAlert) {
            showToastr("error", error.response.data.messages.error);
          }
        } else if (error.response.data.error) {
          if (!props.disabledAlert) {
            showToastr("error", error.response.data.messages);
          }
        }
        return error.response.data;

        if (error.response.status !== 422) throw error;
        setErrors(error.response.data.errors);
      });
  };

  // const postapi_services = async ({ setErrors, disabledAlert, ...props }) => {
  //   // await csrf()
  //   console.log("disabledAlert");
  //   console.log(disabledAlert);

  //   var urllocal = api_path;
  //   if (props.api_path) {
  //     urllocal = props.api_path;
  //     delete props.api_path;
  //   }
  //   if (setErrors) {
  //     setErrors([]);
  //   }

  //   let url = `${api_axios}${urllocal}`;
  //   if (props.customUrl) {
  //     url = `${api_axios}${props.customUrl}`;
  //     delete props.customUrl;
  //   }

  //   await axios(handleget_headers_params()).get(`api/csrf-token`, props);
  //   return await axios(handleget_headers_params())
  //     .post(url, props)
  //     .then((res) => {
  //       if (!disabledAlert) {
  //         showToastr("success", "Tambah data berhasil!");
  //       }
  //       return res.data;
  //     })
  //     .catch((error) => {
  //       // if (!disabledAlert) {
  //       //   let msgerror = "Tambah data gagal!";
  //       //   if (error.response.data.error) {
  //       //     msgerror += `. ${error.response.data.messages}`;
  //       //   }
  //       //   showToastr("error", msgerror);
  //       // }
  //       // if (
  //       //   error.response.data.errors ==
  //       //   "Ada risk sasaran yang belum di accept / avoid"
  //       // ) {
  //       //   showToastr("error", error.response.data.errors);
  //       // }
  //       // if (error.response.data.errors) {
  //       //   setErrors(error.response.data.errors);
  //       // }
  //       // return error.response.data;

  //       // if (error.response.status !== 422) throw error;

  //       let msgerror = "Tambah data gagal!";
  //       if ((error?.response?.data?.error || false)) {
  //         if ((error.response.data.messages?.errors || false)) {
  //           msgerror += `. ${error.response.data.messages.errors}`;
  //         }

  //         if ((error.response.data?.errors || false)) {
  //           setErrors(error.response.data.errors);
  //         }
  //       }

  //       return error.response.data;
  //     });
  // };

  const postapi_services = async ({ setErrors, disabledAlert, ...props }) => {
    console.log("disabledAlert", disabledAlert);

    let urllocal = api_path;
    if (props.api_path) {
      urllocal = props.api_path;
      delete props.api_path;
    }

    if (setErrors) setErrors([]);

    let url = `${api_axios}${urllocal}`;
    if (props.customUrl) {
      url = `${api_axios}${props.customUrl}`;
      delete props.customUrl;
    }

    try {
      await axios(handleget_headers_params()).get(`api/csrf-token`, props);
      const res = await axios(handleget_headers_params()).post(url, props);
      if (!disabledAlert) {
        showToastr("success", "Tambah data berhasil!");
      }

      return res.data;
    } catch (error) {
      let msgerror = "Tambah data gagal!";

      if (error?.response?.data?.error) {
        if (error.response.data.messages?.errors) {
          msgerror += `. ${error.response.data.messages.errors}`;
        }

        if (error.response.data.errors && setErrors) {
          setErrors(error.response.data.errors);
        }
      }
      if (!disabledAlert) {
        showToastr("error", msgerror);
      }

      return error.response?.data || { error: true, message: msgerror };
    }
  };

  const putapi_services = async ({ setErrors, ...props }) => {
    // await csrf()

    var urllocal = api_path;
    if (props.api_path) {
      urllocal = props.api_path;
    }
    if (setErrors) {
      setErrors([]);
    }

    const id = props.id;
    delete props.id;
    delete props.api_path;

    let url = `${api_axios}${urllocal}`;
    if (props.customUrl) {
      url = `${api_axios}${props.customUrl}`;
      delete props.customUrl;
    }

    if (id) url = url + "/" + id;

    await axios(handleget_headers_params()).get(`api/csrf-token`, props);
    return await axios(handleget_headers_params())
      .put(`${url}`, props)
      .then((res) => {
        if (!props.disabledAlert) {
          showToastr("success", "Ubah data berhasil!");
        }
        return res.data;
      })
      .catch((error) => {
        // if (!props.disabledAlert) {
        //   let msgerror = "Ubah data gagal!";
        //   if (error.response.data.error) {
        //     msgerror += `. ${error.response.data.messages}`;
        //   }
        //   showToastr("error", msgerror);
        // }
        // if (error.response.data.errors) {
        //   setErrors(error.response.data.errors);
        // }
        // return error.response.data;

        // if (error.response.status !== 422) throw error
        // setErrors(error.response.data.errors)

        let msgerror = "Update data gagal!";
        if (error?.response?.data?.error || false) {
          if (error.response.data.messages?.errors || false) {
            msgerror += `. ${error.response.data.messages.errors}`;
          }

          if (error.response.data?.errors || false) {
            setErrors(error.response.data.errors);
          }
        }

        return error.response.data;
      });
  };

  const deleteapi_services = async ({ setErrors, ...props }) => {
    // await csrf()

    var urllocal = api_path;
    if (props.api_path) {
      urllocal = props.api_path;
    }
    if (setErrors) {
      setErrors([]);
    }

    const id = props.id;
    delete props.id;

    await axios(handleget_headers_params()).get(`api/csrf-token`, props);
    return await axios(handleget_headers_params())
      .delete(`${api_axios}${urllocal}/${id}`, props)
      .then((res) => {
        if (!props.disabledAlert) {
          showToastr("success", "Hapus data berhasil!");
        }
        return res.data;
      })
      .catch((error) => {
        if (!props.disabledAlert) {
          let msgerror = "Hapus data gagal!";
          if (error.response.data.error) {
            msgerror += `. ${error.response.data.messages}`;
          }
          showToastr("error", msgerror);
        }
        return error.response.data;

        // if (error.response.status !== 422) throw error
        // setErrors(error.response.data.errors)
      });
  };

  const getapi_services_likelihood = async ({ setErrors, ...props }) => {
    if (setErrors) {
      setErrors([]);
    }

    var urllocal = api_path;
    if (props.api_path) {
      urllocal = props.api_path;
    }

    const filter_url = initFilterUrlLikelihood({
      url: `${api_axios}${urllocal}`,
      filter: props.filter,
    });

    if (controller[urllocal]) controller[urllocal].abort();

    controller[urllocal] = new AbortController();

    return await axios(handleget_headers_params())
      .get(filter_url, {
        ...props,
        signal: controller[urllocal].signal,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response == undefined) return { error };
        else return error.response.data;
      });
  };

  return {
    getapi_services,
    getapi_servicesid,
    postapi_services,
    putapi_services,
    deleteapi_services,
    getapi_services_likelihood,
  };
};
